import { createSlice } from '@reduxjs/toolkit'

export const areaCodes = [
  '02',
  '031',
  '032',
  '033',
  '041',
  '042',
  '043',
  '044',
  '051',
  '052',
  '053',
  '054',
  '055',
  '061',
  '062',
  '063',
  '064',
  '010',
  '011',
  '016',
  '017',
  '018',
  '019',
  '050',
  '070',
  '080',
  '0502',
  '0503',
  '0504',
  '0505',
  '0506',
  '0507',
  '국번없음',
]

const initialState = {
  areaCode: '02',
  exchange: '',
  lineNumber: '',
}

export const validatePhoneNumber = (active, state) => ({
  areaCode: active && !state.areaCode && '전화번호를 입력하세요.',
  exchange:
    active && !state.exchange.match(/^[0-9]{3,4}$/) && '전화번호를 입력하세요.',
  lineNumber:
    active &&
    !state.lineNumber.match(/^[0-9]{3,4}$/) &&
    '전화번호를 입력하세요.',
})

export const getPhoneNumberAssetData = ({
  areaCode,
  exchange,
  lineNumber,
}) => ({
  type: 'PHONE_NUMBER',
  data: {
    phoneNumber: [areaCode === '국번없음' ? '' : areaCode, exchange, lineNumber]
      .filter(e => e.length > 0)
      .join('-'),
  },
})

const phoneNumberSlice = createSlice({
  name: 'phoneNumber',
  initialState,
  reducers: {
    reset: () => initialState,
    setAreaCode: (state, { payload: areaCode }) => {
      state.areaCode = areaCode
    },
    setExchange: (state, { payload: exchange }) => {
      state.exchange = exchange
    },
    setLineNumber: (state, { payload: lineNumber }) => {
      state.lineNumber = lineNumber
    },
    setPhoneNumber: (state, { payload: { phoneNumber } }) => {
      const splitNumber = phoneNumber.split('-')
      if (splitNumber.length === 3) {
        ;[state.areaCode, state.exchange, state.lineNumber] = splitNumber
      } else {
        state.areaCode = '국번없음'
        ;[state.exchange, state.lineNumber] = splitNumber
      }
    },
  },
})

export const {
  reset,
  setAreaCode,
  setExchange,
  setLineNumber,
  setPhoneNumber,
} = phoneNumberSlice.actions

export default phoneNumberSlice.reducer
